export default "__VITE_ASSET__CdYI3CDy__"